type DataLayerObject = Record<string, unknown>

/**
 * Push a custom event onto the Google Tag Manager dataLayer.
 *
 * No-ops safely when GTM isn't present — local dev, the GTM_CONTAINER_ID build
 * var being unset (so the container snippet in gatsby-ssr never creates
 * `window.dataLayer`), or GTM blocked by an ad blocker. Same defensive posture
 * as trackLead(): we never assume the tag is loaded.
 *
 * The GA4 tags/triggers that turn these dataLayer events into GA4 events live in
 * the GTM web UI, NOT in this repo — see SETUP.md Step 8. Event/param names here
 * are the contract the GTM container keys off of; renaming one silently breaks
 * the matching trigger. Keep them stable.
 */
export function trackEvent(event: string, params?: DataLayerObject): void {
  if (typeof window === "undefined") return
  const w = window as unknown as { dataLayer?: DataLayerObject[] }
  // Bail when the container never initialized dataLayer (GTM absent/dormant).
  if (!Array.isArray(w.dataLayer)) return
  w.dataLayer.push({ event, ...params })
}
